import {IAppState} from '../../core/redux/IAppState';
import {useDispatch, useSelector} from 'react-redux';
import { getErroredCommentHistory, getGuestCommentHistory, getLoadingCommentHistory } from './module';
import {GuestDetails} from '../guestDetails';
import ImmutableMap from '../../language/ImmutableMap';
import {EntitlementHotlist} from '../entitlements/models';
import {Resort} from '../../resortDetails/resort';
import {GuestComment} from './guestComment';
import * as R from 'ramda';
import {getHotlistComments} from '../hotlist/module';
import {useEffect} from 'react';
import {getGuestCommentsAction} from './getGuestCommentsAction';
import {MODAL_SIZE} from '../../layout/modal/modalSize';
import ModalTitleHeader from '../../layout/modal/ModalTitleHeader';
import comment from '../../assets/icons/comment.svg';
import ModalView, {ModalContent} from '../../layout/modal/ModalView';
import {CommentHistoryView} from './CommentHistoryView';
import {fullName} from '../module';
import * as React from 'react';
import { getResource } from '../../language/resources/getResource';



type Props = {
  guestId: string;
  onDismiss: () => void;
}

const getEntitlementHotlistComments = (
  guest: GuestDetails,
  guestId: string,
  entitlementHotlists: ImmutableMap<EntitlementHotlist[]>,
  resortList: Resort[] | undefined,
): GuestComment[] => R.flatten((guest.entitlements || []).map(
  ent => getHotlistComments(guestId, entitlementHotlists.get(String(ent.entitlementId)), resortList || []),
));

export const GuestCommentHistoryModal = (props: Props) => {
  const dispatch = useDispatch();
  const resources = useSelector((state: IAppState) => state.locale);

  const {guest, commentHistory, isLoadingCommentHistory, commentHistoryLoadError} = useSelector((state: IAppState) => {
    const guest = state.guests.get(props.guestId);
    return {
      guest:                   guest,
      commentHistory:          R.concat(
        getGuestCommentHistory(state, props.guestId),
        getEntitlementHotlistComments(
          guest,
          props.guestId,
          state.entitlementHotlists,
          state.resortDetails?.allResorts?.getValues(),
        ),
      ),
      isLoadingCommentHistory: !!getLoadingCommentHistory(state, props.guestId),
      commentHistoryLoadError: getErroredCommentHistory(state, props.guestId),
    };
  });

  useEffect(() => {
    const getCommentHistory = (guestId: string) => dispatch(getGuestCommentsAction(guestId));
    getCommentHistory(props.guestId);
  }, [dispatch, props.guestId]);

  return (
    <ModalView
      onDismiss={props.onDismiss}
      size={MODAL_SIZE.DYNAMIC}
    >
      <ModalTitleHeader resources={resources} heading={getResource(resources, 'COMMENT_HISTORY_VIEW_COMMENTS')} icon={comment} onDismiss={props.onDismiss} />

      <ModalContent>
        <CommentHistoryView
          guestName={fullName(guest)}
          commentHistory={commentHistory}
          commentHistoryLoadError={commentHistoryLoadError}
          isLoadingCommentHistory={isLoadingCommentHistory}
        />
      </ModalContent>
    </ModalView>
  )


}